import OddsBoostBannerImpl from './odds-boost-banner.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display boost banner.
 *
 * @class OddsBoostBanner
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * OddsBoostBanner prop types.
 *
 * @property {Mojito.Services.Betslip.types.OddsBoostToken} oddsBoostToken - Object containing odds boost token for the bet.
 * @property {string} betId - Bet id.
 * @property {Mojito.Services.Bets.types.LEG_SORT} legSort - Leg sort.
 * @property {Mojito.Services.Bets.types.BET_WAY} [betWay] - Bet way.
 * @property {string} [currencyCode] - Currency code to use.
 *
 * @memberof Mojito.Modules.BetslipView.OddsBoostBanner
 */
const propTypes = {
    oddsBoostToken: PropTypes.object.isRequired,
    betId: PropTypes.string.isRequired,
    legSort: PropTypes.string.isRequired,
    betWay: PropTypes.string,
    currencyCode: PropTypes.string,
};

export default UIView('OddsBoostBanner', OddsBoostBannerImpl, propTypes);
